import React from 'react';
import './Loading.css'; 

function Loading() {
  return ( 
      <div className='loadding-ppl'>
        <img src="https://cdn.nexustech.com.co/images/Isotipo_N_Tech.png" alt="" />&nbsp;Espere...
      </div> 
  );
}

export default Loading;